// Teacher normalization helpers used by the Admin Teachers dashboard flow.
// Keep this module small and dependency-free so other pages aren't affected.

export function normalizeTeacher(raw) {
  if (!raw) return null;

  const id = raw.id ?? raw.teacher_id ?? null;
  const first = (raw.first_name ?? '').trim();
  const last = (raw.last_name ?? '').trim();
  const fallbackName = `${first} ${last}`.trim();

  const name = (raw.name ?? fallbackName ?? '').trim();

  return {
    ...raw,
    id,
    name: name || (id != null ? `ID ${id}` : ''),
    first_name: raw.first_name ?? (name && !raw.first_name ? name.split(' ')[0] : raw.first_name),
    last_name: raw.last_name ?? raw.last_name,
    email: raw.email ?? raw.email,
    username: raw.username ?? raw.username,
    phone_number: raw.phone_number ?? raw.phone ?? raw.phoneNumber,
    // Normalize google calendar id naming variations
    google_calendar_id: raw.google_calendar_id ?? raw.googleCalendarId ?? raw.google_calendar ?? raw.googleCalendarID,
  };
}

export function mergeTeacher(base, incoming) {
  if (!base) return normalizeTeacher(incoming);
  if (!incoming) return normalizeTeacher(base);
  const b = normalizeTeacher(base) || {};
  const i = normalizeTeacher(incoming) || {};

  // Prefer incoming values when present, but keep any extra metadata from base.
  return {
    ...b,
    ...i,
    id: i.id ?? b.id,
    name: (i.name || b.name || '').trim(),
  };
}

export function teacherDisplayName(t) {
  const nt = normalizeTeacher(t);
  return nt?.name || '';
}

